"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteSearch = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var debounced_callback_1 = require("../../hooks/debounced-callback");
var input_1 = require("../input");
var search_result_list_1 = require("./components/search-result-list");
function AutoCompleteSearch(props) {
    var searchFetch = props.searchFetch, data = props.data, formatter = props.formatter, _a = props.debounce, debounce = _a === void 0 ? 100 : _a, handleResults = props.handleResults, handleSearch = props.handleSearch, hideNotFound = props.hideNotFound, initialQuery = props.initialQuery, labelHint = props.labelHint, _b = props.minSearchLength, minSearchLength = _b === void 0 ? 0 : _b, onSelectValue = props.onSelectValue, placeholder = props.placeholder, _c = props.deleteValueOnClear, deleteValueOnClear = _c === void 0 ? false : _c, testId = props.testId;
    var _d = (0, react_1.useState)(initialQuery || null), selectedSearchQuery = _d[0], setSelectedSearchQuery = _d[1];
    var _e = (0, react_1.useState)(initialQuery || null), search = _e[0], setSearch = _e[1];
    var _f = (0, react_1.useState)(false), searchFocused = _f[0], setSearchFocused = _f[1];
    var shouldSearchFetch = search && search.length >= minSearchLength;
    var debouncedSearchFetch = (0, debounced_callback_1.useDebouncedCallback)(function (value) {
        searchFetch(value);
    }, debounce);
    (0, react_1.useEffect)(function () {
        if (debouncedSearchFetch && shouldSearchFetch) {
            debouncedSearchFetch(search);
        }
    }, [search]);
    if (handleResults) {
        handleResults(data);
    }
    function handleSelect(value, option) {
        var title = option.title, optionValue = option.key;
        var label = typeof title === 'object' ? title.join(' ') : title;
        if (labelHint) {
            label = "".concat(label, " (").concat(optionValue, ")");
        }
        onSelectValue(value);
        setSelectedSearchQuery(label);
        setSearchFocused(false);
    }
    return (react_1.default.createElement(StyledAutoCompleteSearch, null,
        react_1.default.createElement(input_1.Input, { testId: testId, type: "search", placeholder: placeholder || 'Type to search...', onChange: function (value) {
                setSelectedSearchQuery(null);
                setSearch(value);
                if (handleSearch) {
                    handleSearch(value);
                }
            }, onFocus: function () { return setSearchFocused(true); }, onBlur: function () { return setSearchFocused(false); }, value: selectedSearchQuery || search, onInput: function (e) { return deleteValueOnClear && !e.currentTarget.value && onSelectValue(undefined); } }),
        search && searchFocused && data && (!hideNotFound || data.length > 0) && (react_1.default.createElement(search_result_list_1.SearchResultList, { formatter: formatter, onSelect: handleSelect, results: data }))));
}
exports.AutoCompleteSearch = AutoCompleteSearch;
var StyledAutoCompleteSearch = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map